import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6jjy4txuzi: FaireBrandEntity = {
  token: "b_6jjy4txuzi",
  type: "brand",
  name: "Indaba Trading",
  avatarUrl:
    "https://cdn.faire.com/fastly/5cac262a84b72addbb1599f2b3d4774582616dc46734e941ff290decc0680f55.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a183b12de7524e7b3a7d658f905c2438f8a91e126d8c13240ac7f8eae80b9e24.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5cac262a84b72addbb1599f2b3d4774582616dc46734e941ff290decc0680f55.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a183b12de7524e7b3a7d658f905c2438f8a91e126d8c13240ac7f8eae80b9e24.jpeg",
  location: "Parksville, BC, CAN",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: false,
  description:
    "As a new South African immigrant to Vancouver Island, Canada, with two small children and no support network, Irene was driven to launch Indaba with a belief that life is better when you surround yourself with meaningful things that provide comfort, pleasure, and beauty. Thirty years later, Indaba has grown to become a Women’s Business Enterprise (WBE) certified home and lifestyle brand. As a women-owned and operated business, Irene and her daughter Alison are proud to empower small businesses - travelling worldwide to source their designs. They deeply love India's rich textile heritage and artisanal traditions and embrace the opportunity to work with the artisans who hand make each item.\n\nIrene was inspired by the Zulu word for \"a gathering of people\": Indaba. This enchanting word embodies Indaba's mission to connect with you through our story, products, and the people who make them. \n\nContact:\n1067 Herring Gull Way\nParksville BC\nCanada V9P 2N1\n[redacted-phone] ext 104\n[redacted-email]\n\nTariffs/Duties: Indaba always pays all import fees and duties; please disregard the default message in your Faire cart. \n\nPlease visit our website www.indabawholesale.com and our Instagram  @indabatradingco to see pictures and videos of the artists hand-making our products.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:35.795Z",
    importedBy: "entity-db-cli",
  },
};
